// extracted by mini-css-extract-plugin
module.exports = {"root":"_e8b919d8","isVariantFourColumns":"_d77caeb2","isVariantFiveColumns":"_cac1aca8"};